import React from 'react';
import { CommonTextProps } from 'components/atoms/text/types/Props';

export default function Paragraph({ text, styles }: CommonTextProps) {
  return <div className={`font-light text-xs sm:text-lg ${styles}`}>{text}</div>;
}
